import { render, staticRenderFns } from "./HrPlanner.vue?vue&type=template&id=1970fc3a&scoped=true"
import script from "./HrPlanner.vue?vue&type=script&lang=js"
export * from "./HrPlanner.vue?vue&type=script&lang=js"
import style0 from "./HrPlanner.vue?vue&type=style&index=0&id=1970fc3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1970fc3a",
  null
  
)

export default component.exports